<template>
  <div class="login-page">
    <el-card class="login-card" shadow="hover">
      <h2>{{ title }}</h2>
      <p class="hint">管理后台仅限授权人员使用</p>
      <el-form @submit.native.prevent="onSubmit">
        <el-form-item label="管理密码">
          <el-input
            v-model="password"
            type="password"
            show-password
            placeholder="请输入管理密码"
            @keyup.enter.native="onSubmit"
          />
        </el-form-item>
        <el-button type="primary" :loading="loading" style="width: 100%" @click="onSubmit">
          登录
        </el-button>
      </el-form>
      <p v-if="appEnv === 'local'" class="dev-hint">本地默认密码见 application.yml 中 aivideoclip.admin.password</p>
    </el-card>
  </div>
</template>

<script>
import { adminLogin } from '../api/client';
import { setAdminToken } from '../utils/authStorage';
import { ADMIN_TITLE, APP_ENV } from '../config';

export default {
  name: 'AdminLogin',
  data() {
    return {
      title: ADMIN_TITLE,
      appEnv: APP_ENV,
      password: '',
      loading: false,
    };
  },
  methods: {
    async onSubmit() {
      if (!this.password) {
        this.$message.warning('请输入密码');
        return;
      }
      this.loading = true;
      try {
        const data = await adminLogin(this.password);
        setAdminToken(data.accessToken);
        this.$emit('success');
        this.$message.success('登录成功');
      } catch (e) {
        this.$message.error(e.message || '登录失败');
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f3f4f6;
}
.login-card {
  width: 400px;
  padding: 8px 4px 4px;
}
.login-card h2 {
  margin: 0 0 8px;
  font-size: 20px;
  text-align: center;
}
.hint {
  text-align: center;
  color: #6b7280;
  font-size: 13px;
  margin: 0 0 20px;
}
.dev-hint {
  margin: 16px 0 0;
  font-size: 12px;
  color: #9ca3af;
  text-align: center;
}
</style>
